export const checkboxItemFlexStyle = (disabled) => ({
  cursor: disabled ? 'not-allowed' : 'pointer',
  gap: '$2',
  userSelect: 'none'
})

export const checkboxItemLabelStyle = {
  fontSize: '14px',
  color: '#333'
}
export const checkboxItemBoxStyle = {
  width: '20px',
  height: '20px',
  border: '2px solid #007A54',
  borderRadius: '4px',
  backgroundColor: 'white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  transition: 'all 0.2s',
  position: 'relative',
  '&:hover': {
    borderColor: '#005A3E'
  }
}

export const checkboxItemBoxTextStyle = {
  color: '#007A54',
  fontSize: '16px',
  fontWeight: 'bold',
  lineHeight: 1
}

export const eventSiteDisplayBoxStyle = {
  backgroundColor: '#F2F2F2',
  border: '1px solid $medium-light-3',
  borderRadius: '10px',
  padding: '$6',
  marginBottom: '$6'
}

export const periodFieldLabelStyle = {
  fontWeight: '$medium',
  fontSize: '$body-medium',
  lineHeight: '$default'
}
